// import backstage from './backstage/';
// import reception from './reception';
import reception from './reception/reception';
import backstage from './backstage/backstage';
export default { ...backstage, ...reception };
